import PhaseOfPlay from "@Enums/PhaseOfPlay";
import { useEffect, useState } from "react";
import { useAnalytics } from "@hooks/common/analytics/use-analytics";
import { AnalyticsEvents } from "@Enums/index";

export interface UsePhasesSelectionResponse {
  draftPhases: PhaseOfPlay[];
  setDraftPhases: (phases: PhaseOfPlay[]) => void;
  handlePhaseClick: (phase: PhaseOfPlay) => void;
  handleSave: () => void;
  handleCancel: () => void;
}

export const usePhasesSelection = (
  initialPhases: PhaseOfPlay[] = [],
  onPhasesSelected?: (phases: PhaseOfPlay[]) => void,
  onCancel?: () => void
): UsePhasesSelectionResponse => {
  const [originalPhases, setOriginalPhases] = useState<PhaseOfPlay[]>(initialPhases);
  const [draftPhases, setDraftPhases] = useState<PhaseOfPlay[]>(initialPhases);

  useEffect(() => {
    setOriginalPhases(initialPhases);
    setDraftPhases(initialPhases);
  }, [initialPhases]);


  const { track } = useAnalytics();

  const handlePhaseClick = (phase: PhaseOfPlay) => {
    const isSelected = draftPhases.includes(phase);
    if (isSelected) {
      setDraftPhases(draftPhases.filter((p) => p !== phase));
    } else {
      setDraftPhases([...draftPhases, phase]);
    }
  };

  const handleSave = () => {
    onPhasesSelected?.(draftPhases);
    track(AnalyticsEvents.practice_settings_adjusted, { phases: draftPhases });
  };

  const handleCancel = () => {
    setDraftPhases(originalPhases);
    onCancel?.();
  };

  return {
    draftPhases,
    setDraftPhases,
    handlePhaseClick,
    handleSave,
    handleCancel,
  };
};
